import { Component } from 'vue-property-decorator';
import { LabelSetting } from '../../../../../../i18n/locale-helper'
import { NotificationTaskProcessModel } from './notification-task-process-model';
import PrintTemplateComponent from './templates/print-template';
import SendMessageTemplateComponent from './templates/send-message';

@Component({
	components: {
		'print-template': PrintTemplateComponent,
		'sendmessage-template': SendMessageTemplateComponent
	}
})
class NotificationTaskProcessComponent extends NotificationTaskProcessModel {
	visibleNotificationList: Boolean = false;
	keySearch: String = null;

	localizationConfig = LabelSetting.Action;
	statusLocalizationSetting = LabelSetting.Status;
	actionLocalizationSetting = LabelSetting.Action;
	reportLocalizationConfig = LabelSetting.Report;

	/**
	 *
	 */
	constructor() {
		super();
	}

	mounted() {
		console.log('notification task process mounted');
	}

	get lblSetting() {
		return LabelSetting.Global;
	}

	created() {
		
	}

	changeFilter(type) {
		this.dtFilterType = type;
	}
	dtFilterType: any = "all";

	/** search by key search */
	searchNotification() {

	}

}

export default NotificationTaskProcessComponent;